import { produce } from 'immer';

import { UpdateInternalProductDescription } from '../../../actions/products/internal/updateInternalProductDescription';
import { ProductsPageStates, ProductsState } from '../../../typings/products';

export function updateInternalProductDescription(
    state: ProductsState,
    action: UpdateInternalProductDescription
): ProductsState {
    return produce(state, draft => {
        draft.pageStatus = ProductsPageStates.ACTION;
    });
}
